import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import buskforwardingdetail from '@root/modules/Busk/Forwarding-Deatil/services/buskforwardingdetail';
import { Button, Col, Form, Input, Row, message } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

const ForwardingCreate = () => {
  const history = useHistory();
  const breadcrumbList = [
    { tittle: '포워딩 업체 관리', url: '' },
    { tittle: '업체 등록', url: '' }
  ];
  const [form] = Form.useForm();

  const [disabled, setDisabled] = useState(true);

  const handleFormChange = () => {
    setDisabled(
      !form.getFieldValue('name') ||
        !form.getFieldValue('manager') ||
        !form.getFieldValue('email') ||
        !form.getFieldValue('country') ||
        !form.getFieldValue('description') ||
        !form.getFieldValue('password') ||
        !form.getFieldValue('locale')
    );
  };
  const onSubmit = async (data: any) => {
    console.log(data, 'HIHI');
    const res = await buskforwardingdetail.createForwarding({
      ...data
    });
    console.log(res);
    if (res?.data) {
      message.success('업체 등록이 완료되었습니다.');
      history.push(`/admin/busk/forwarding/${res?.data?.id}`);
    } else {
      message.error('업체 등록에 실패했습니다.');
    }
  };
  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <div
          style={{
            padding: '1rem',
            backgroundColor: 'white'
          }}
          id="busk-DetailForm"
        >
          <Form
            name="basic"
            layout="vertical"
            className="forwarding-form"
            form={form}
            onFinish={onSubmit}
            onValuesChange={handleFormChange}
          >
            <Row gutter={24}>
              <Col flex={'1'}>
                <Row>
                  <Form.Item label="업체명" name="name">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="업체 관리자명" name="manager">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="아이디 (이메일)" name="email">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="비밀번호" name="password">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="국가명" name="country">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="소통 언어" name="locale">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="주요 업무" name="description">
                    <TextArea rows={5} style={{ borderRadius: 8 }} />
                  </Form.Item>
                </Row>
              </Col>
            </Row>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingTop: 20,
                marginTop: 20,
                borderTop: '1px solid #EBECEF'
              }}
            >
              <Button
                disabled={disabled}
                className="btn-disabled"
                htmlType="submit"
                style={{
                  width: 80,
                  height: 28,
                  color: 'white',
                  borderRadius: 8,
                  fontWeight: 500,
                  fontSize: 12
                }}
              >
                등록
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForwardingCreate;
